import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
/* eslint-disable import/no-duplicates */
import { patchComponent, useSlots, useAttrsV2, passAttrs, passListeners, useListeners } from '../_use';
import { isVue2 } from 'vue-demi';
export default patchComponent({
  name: 'vc-transition',
  render() {
    const h = arguments[0];
    const slots = useSlots(this);
    const attrs = useAttrsV2(this);
    if (isVue2) {
      var _slots$default;
      return h("transition", _mergeJSXProps([{}, passAttrs(attrs), {}, passListeners(useListeners(this))]), [(_slots$default = slots.default) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots)]);
    }
  }
});